module.exports = __webpack_public_path__ + "img/image1@2x.54055f22.png";